import { InjectionToken } from '@angular/core';
import { MatDateFormats } from '@angular/material';
export const JALALI_MOMENT_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'jYYYY/jMM/jDD',
        // dateInput: 'l',
    },
    display: {
        dateInput: 'jYYYY/jMM/jDD',
        //monthYearLabel: 'jYYYY jMMMM',
        monthYearLabel: 'jYYYY',
        dateA11yLabel: 'jYYYY/jMM/jDD',
        //monthYearA11yLabel: 'jYYYY jMMMM'
        monthYearA11yLabel: 'jYYYY'
    }
}; 

// export const MOMENT_FORMATS: InjectionToken<MOMENT_FORMATS>;



// WEBPACK FOOTER //
// ./src/app/components/mat-core/jalali_moment_formats.ts